import {ObjectType} from 'app-core/framework/CoreObjectConstants';
import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';

/**
 * Checks if a config variable is for a specific domain object type.
 * Handles both singular domain types and arrays of domain types.
 */
export function isDomainConfigVariable(
  variable: {variableTypeConfigSpec: PipelineConfigJsonSpec},
  objectType: ObjectType
): boolean {
  const spec = variable.variableTypeConfigSpec;
  if (spec.kind === 'domain' && spec.types?.some((type) => type === objectType)) {
    return true;
  }
  if (spec.kind === 'array' && spec.elementSpec) {
    const elementSpec = spec.elementSpec;
    return elementSpec.kind === 'domain' && elementSpec.types?.some((type) => type === objectType);
  }
  return false;
}

export function isFileConfigVariable(variable: {variableTypeConfigSpec: PipelineConfigJsonSpec}): boolean {
  return isDomainConfigVariable(variable, 'FILE');
}

export function getFileConfigVariables<T extends {variableTypeConfigSpec: PipelineConfigJsonSpec}>(
  configVariables: Array<T>
): Array<T> {
  return configVariables.filter((variable) => isFileConfigVariable(variable));
}

export function prepareFileVariableValue<T>(variable: {configVariableKey: string}, value: T): T | T[] {
  return variable.configVariableKey === 'fileIds' ? [value] : value;
}
